import { certifications, complianceAreas } from '@/mocks/homeData';

export default function Compliance() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F9FC]">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Compliance & Certifications
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Internationally Recognized<br />Standards
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            Our operations meet the most stringent international compliance and certification requirements.
          </p>
        </div>

        {/* <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3 mb-16">
          {certifications.map((cert, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg p-4 border border-[#E6EAF0] text-center hover:border-primary-200 hover:shadow-sm transition-all duration-300 animate-on-scroll animate-on-scroll-delay-${(i % 5) + 1}`}
            >
              <div className="w-9 h-9 mx-auto rounded-lg bg-primary-50 flex items-center justify-center mb-2.5">
                <i className={`${cert.icon} text-primary-500 text-base`}></i>
              </div>
              <div className="text-xs font-heading font-semibold text-foreground-800 mb-1">{cert.name}</div>
              <div className="text-[10px] text-foreground-400 leading-tight">{cert.description}</div>
            </div>
          ))}
        </div> */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 animate-on-scroll">
          {complianceAreas.map((area, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-[#E6EAF0]">
              <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mb-4">
                <i className={`${area.icon} text-accent-500 text-lg`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-2">{area.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}